import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { DatePickerGlobalOptions, serviceConstants } from 'src/app/constants/service.constants';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { Document_Upload_File } from 'src/app/models/common';
import * as $ from 'jquery';
import { UserService } from "src/app/services/user.service";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-grants-budget-record-expenditure',
  templateUrl: './grants-budget-record-expenditure.component.html',
  styleUrls: ['./grants-budget-record-expenditure.component.scss']
})
export class GrantsBudgetRecordExpenditureComponent implements OnInit {

  @Input() public Content: any;
  BUGET_TYPE_ID: string;
  BUDGET_SUB_TYPE_ID: string;
  TOTAL_FEE: number;
  REQUESTED_AMOUNT: number;
  ALLOCATION_AMOUNT: number;
  EXPENDITURE_AMOUNT: any;

  uploadedFiles: Document_Upload_File[];
  formFields;
  stateOptions = stateOptionsSample;

  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  appid: string = "";
  grantcurrencycode: any = "";
  granttype: number;
  recordExpenditureForm: UntypedFormGroup;
  expAmount: any;
  screen: string;
  requestId: string;

  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  staticformFields: any;
  expStaticFields: any;
  StatusStr: any;
  Expenditureamount: any=null;
  balanceamount: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private userService: UserService,
    private commonService: CommonService
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  
  getStaticFiledsData(screenCode: string) {
    
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe(summary => {
        if(screenCode == 'SCR-026'){
          this.staticformFields = summary["Data"]; 
        } else{
          this.expStaticFields = summary["Data"]; 
        }
      });
  }

  ngOnInit() {
    var grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    this.appid = grantapp.ID;
    this.getStaticFiledsData('SCR-026');
    this.getStaticFiledsData('SCR-030');
    this.requestId = this.Content.content.id;
    this.heading = this.Content.heading;
    this.screen = this.Content.content.screen;

    this.granttype = grantapp.GRANT_TYPE;
    this. getLatestSymbol();
    // if (this.granttype == 1)
    //   this.grantcurrencycode = this.userService.getGrantCMECurrencySymbol();
    // else if (this.granttype == 2)
    //   this.grantcurrencycode = this.userService.getGrantSponsorCurrencySymbol();
    // else if (this.granttype == 3)
    //   this.grantcurrencycode = this.userService.getGrantCharitableCurrencySymbol();

    // if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
    //   this.grantcurrencycode = "$";

    this.recordExpenditureForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      BUGET_TYPE_ID: new UntypedFormControl(""),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl(""),
      NOTES: new UntypedFormControl(""),
      REQUESTED_AMOUNT: new UntypedFormControl(""),
      ALLOCATION_AMOUNT: new UntypedFormControl(""),
      EXPENDITURE_AMOUNT: new UntypedFormControl("", [Validators.required]),
      TOTAL_FEE: new UntypedFormControl(""),
      BALANCE_AMOUNT: new UntypedFormControl("")
    });

    if (this.heading == "View") {
      this.GetEditData();
      this.recordExpenditureForm.disable();
    }
    if (this.heading == "Edit") {
      this.GetEditData();
      this.recordExpenditureForm.controls["BUGET_TYPE_ID"].disable();
      this.recordExpenditureForm.controls["BUDGET_SUB_TYPE_ID"].disable();
      this.recordExpenditureForm.controls["NOTES"].disable();
      this.recordExpenditureForm.controls["REQUESTED_AMOUNT"].disable();
      this.recordExpenditureForm.controls["TOTAL_FEE"].disable();
      this.recordExpenditureForm.controls["ALLOCATION_AMOUNT"].disable();
     
    }

    this.recordExpenditureForm.controls["BALANCE_AMOUNT"].disable();
  }
  GetEditData(): void {
    this.summaryService.getReconsiliation(this.Content.content.id,this.appid).subscribe(summary => {
      this.recordExpenditureForm.patchValue({
        ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        BUGET_TYPE_ID: summary["BUGET_TYPE_ID"],
        BUDGET_SUB_TYPE_ID: summary["BUDGET_SUB_TYPE_ID"],
        TOTAL_FEE: summary["TOTAL_FEE"],
        REQUESTED_AMOUNT: summary["REQUESTED_AMOUNT"],
        ALLOCATION_AMOUNT: summary["ALLOCATION_AMOUNT"],
        NOTES: summary["NOTES"]
      });
      if(summary["Status"] > 1){
        this.grantcurrencycode = summary["CURRENCY_SYMBOL"];
      }
      this.BUGET_TYPE_ID = summary["BUGET_TYPE_ID"];
      this.BUDGET_SUB_TYPE_ID = summary["BUDGET_SUB_TYPE_ID"];
      this.TOTAL_FEE = parseInt(summary["TOTAL_FEE"]);
      this.REQUESTED_AMOUNT = parseInt(summary["REQUESTED_AMOUNT"]);
      this.ALLOCATION_AMOUNT = parseInt(summary["ALLOCATION_AMOUNT"]);
      this.uploadedFiles = summary.uploadFiles;
   
    this.recordExpenditureForm.controls["EXPENDITURE_AMOUNT"].setValue(summary["EXPENDITURE_AMOUNT"] == 0 ? '': summary["EXPENDITURE_AMOUNT"]);    
    this.Expenditureamount = summary["EXPENDITURE_AMOUNT"] == 0 ? '': summary["EXPENDITURE_AMOUNT"];
      this.balanceamount = this.ALLOCATION_AMOUNT - this.Expenditureamount;

      this.recordExpenditureForm.controls["BALANCE_AMOUNT"].setValue(parseInt(this.balanceamount));
    });
  }
  getLatestSymbol()
  {
    if (this.granttype == 1)
    {
      this.userService.getGrantCMECurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 2)
    {
      this.userService.getGrantSponsorCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 3)
    {
      this.userService.getGrantCharitableCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
  }
  SaveReconsiliation() {
    if (this.validateControls()) {
      let formData = this.recordExpenditureForm.value;

      formData["APPLICATION_ID"] = this.appid;     
      formData["EXPENDITURE_AMOUNT"] = parseInt(formData["EXPENDITURE_AMOUNT"]);
      formData["uploadFiles"] = this.uploadedFiles;
      formData["SCREEN_NAME"] = this.screen;
      formData["BUDGET_REQUEST_ID"] = this.requestId;

      let uploadData = new FormData();
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        if (this.uploadedFiles[i].Status == "Add") {
          uploadData.append(this.uploadedFiles[i].ID, this.uploadedFiles[i].File);
          this.uploadedFiles[i].File = null;
        }
      }

      uploadData.append("reconciliation", JSON.stringify(formData));
      if (this.heading == "Add") {
        this.summaryService.Upload('api/gmconciliation/insertreconciliation', uploadData).subscribe(summary => {
          if (summary.Status == 0)
          {
          this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result1 => {
            if (result1.Status == 0) {
              this.commonService.SuccessBanner('Data has been saved successfully');
              this.modalRef.close();
            }
            else
            {
              this.commonService.ValidationBanner(result1.Message);
            }
          });
          }
          else
          {
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }
      else {
        this.summaryService.Upload('api/gmconciliation/updatereconciliation', uploadData).subscribe(summary => {
          if (summary.Status === 0 ||summary.ErrorCode=="NOCHANGES")
          {
            this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result1 => {
              if(result1.ErrorCode === "NOCONTROLS")
              {
                if (summary.Status == 0) {
                  this.commonService.SuccessBanner('Budget expenditure details updated successfully');
                  this.modalRef.close('yes');
                } else {
                  this.commonService.ValidationBanner(summary.Message);
                }
              }
              else
              {
                if (summary.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(summary.Message);
                }
                else {
                  this.commonService.SuccessBanner('Budget expenditure details updated successfully');
                  this.modalRef.close('yes');
                }
              }
            });
          }
          else{
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }
    }
  }

  validateControls() {
    
    var formDate = this.recordExpenditureForm.value;
    formDate["ALLOCATION_AMOUNT"] = this.recordExpenditureForm.controls['ALLOCATION_AMOUNT'].value;

    var message = "";
    var isValid = true;
    if(this.expStaticFields?.EXPENDITURE_AMOUNT.IS_Display && this.expStaticFields?.EXPENDITURE_AMOUNT.IS_MANDATORY){
      if (formDate.EXPENDITURE_AMOUNT === null || formDate.EXPENDITURE_AMOUNT === "" || formDate.EXPENDITURE_AMOUNT === undefined || parseInt(formDate["EXPENDITURE_AMOUNT"]) == 0) {
        $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.expStaticFields?.EXPENDITURE_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
        //return false;
      } else {
        $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }   

    if (this.expStaticFields?.RECONCILIATION_UPLOAD.IS_Display && this.expStaticFields?.RECONCILIATION_UPLOAD.IS_MANDATORY) {
      if (this.uploadedFiles.length ==0) {
        $("#RECONCILIATION_UPLOAD").addClass("ng-touched ng-invalid validate-error");
        $("#RECONCILIATION_UPLOAD").removeClass("ng-untouched ng-valid");
        message += `Please upload ${this.expStaticFields?.RECONCILIATION_UPLOAD.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#RECONCILIATION_UPLOAD").addClass("ng-untouched ng-valid");
        $("#RECONCILIATION_UPLOAD").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    
    if (formDate["EXPENDITURE_AMOUNT"] != null && parseInt(formDate["EXPENDITURE_AMOUNT"]) > parseInt(formDate["ALLOCATION_AMOUNT"]) ) {
      $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
      $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
      message += "The expenditure amount cannot be greater than the allocated amount<br/>";
      isValid = false;
    } else {
      $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
      $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message);
      return isValid;
    }
    return isValid;
  }

  uploadchange(event): void {
    if (this.uploadedFiles == undefined || this.uploadedFiles == null) {
      this.uploadedFiles = [];
    }

    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];

    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        hasUnFormat = true;
      }
      else {
        let hasValue;

        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        if (this.uploadedFiles?.length > 0) {
          hasValue = this.uploadedFiles?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if (hasValue?.length > 0) {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } else {

          if(this.expStaticFields?.RECONCILIATION_UPLOAD.IS_MULTISELECT){
            this.uploadedFiles.push(uploadFile);
          } else{
            this.uploadedFiles = [];
            this.uploadedFiles.push(uploadFile);
          }
        }
      }
    }

    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
    
    if(hasMultipleFiles){
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
    }
  }

  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.uploadedFiles = this.uploadedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
      let index = this.uploadedFiles.findIndex(x => x.ID == file.ID);
      this.uploadedFiles.splice(index, 1);
    }
  }

  OpenFile(item: Document_Upload_File)   {
    
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

}
